export const USER_STATUSES = [
  { alias: 'active', id: 1, title: 'Active' },
  { alias: 'inactive', id: 2, title: 'Inactive' },
]
